
<template>
  <v-form ref="filterForm" @submit.prevent="submitFilter()" class="filter">
    <v-row dense>
      <v-col cols="12" md="1" class="mx-md-6 mx-lg-0">
        <div
          class="d-flex align-baseline"
          :class="!$vuetify.breakpoint.xsOnly ? 'justify-space-around' : 'mb-6'"
        >
          <div class="mx-md-1 mx-lg-2 mr-2">
            <span>{{ $t("filters") }}</span>
          </div>
          <div class="flex-grow-1 mr-2">
            <v-btn
              outlined
              color="#6A6E7B"
              block
              class="btn--width40"
              :disabled="!cptdTotalFilters"
              @click="clearFilterForm()"
            >
              <v-badge
                color="red"
                overlap
                bottom
                :value="cptdTotalFilters"
                :content="cptdTotalFilters"
              >
                <v-icon> mdi-filter </v-icon>
              </v-badge>
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filters.CUSTOMER_PO"
          :label="$t('purchaseOrder')"
          outlined
          dense
          clearable
          @click:clear="clearField('CUSTOMER_PO')"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filters.TRANSACTION_NUMBER"
          :label="$t('Numero de Factura')"
          type="number"
          outlined
          dense
          clearable
          @click:clear="clearField('TRANSACTION_NUMBER')"
        />
      </v-col>
      <v-col cols="12" md="2">
        <input-date
          v-model="filters.initialDateKey"
          :label="$t('dataFaturamentoInicial')"
          :rules="[]"
          readonly
          @click:clear="clearField(initialDateKey)"
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <input-date
          v-model="filters.finalDateKey"
          :label="$t('dataFaturamentoFinal')"
          :rules="[dateMustBeBiggerRule]"
          readonly
          @click:clear="clearField(finalDateKey)"
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <autocomplete-line
          v-model="filters.DESC_LINE"
          :label="$t('line')"
          outlined
          @click:clear="clearField('DESC_LINE')"
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          v-model="filters.STATUS_PAYMENT"
          :items="items"
          item-text="text"
          item-value="value"
          dense
          outlined
          @change="clearSelect(filters.STATUS_PAYMENT)"
          :label="$t('status')"
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filters.PRODUCTPROP"
          :label="$t('product')"
          outlined
          dense
          clearable
          @click:clear="clearField('PRODUCTPROP')"
        />
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          depressed
          color="#D8D8D8"
          :block="$vuetify.breakpoint.xsOnly"
          type="submit"
        >
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          depressed
          color="#D8D8D8"
          @click="downloadOrders()"
          :disabled="this.disabled"
        >
          <v-icon
          color="green"
          > 
          mdi-file-excel-box 
        </v-icon>
          Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <TLoading v-model="loading" />
  </v-form>
</template>

<script>
import mixinFilters from "@/mixins/mixinFilter";
import InputDate from "@/arch/components/InputDate";
import AutocompleteLine from "@/components/AutocompleteLine.vue";
import XLSX from 'xlsx/xlsx';
import {currency, formatDateValue} from "./../../../helpers/filter";

export default {
  name: 'OrdersFiltersComponent',
  mixins: [mixinFilters],
  components: {
    InputDate,
    AutocompleteLine,
  },
  data() {
    return {
      path: "facturacion",
      months: [],
      initialDateKey: "ORDER_DATE_INICIAL",
      finalDateKey: "ORDER_DATE_FINAL",
      items:[
        { value: '', text: '' },
        { value: 'Total', text: this.$i18n.t('Total') },
        { value: 'Pendiente', text: this.$i18n.t('Pendiente') },
        { value: 'Parcial', text: this.$i18n.t('Parcial') },
        { value: 'Expirado', text: this.$i18n.t('Expirado') },
      ],
      filters: {
        CUSTOMER_PO: "",
        DESCRIPTION: "",
        DESC_LINE: "",
        ITEM: "",
        PRODUCTPROP: "",
        STATUS_PAYMENT:"",
        initialDateKey: this.getTreeMonthOldFilter(),
        finalDateKey: this.getNowDateFilter(),
        TRANSACTION_NUMBER: "",
      },
    };
  },
  methods: {
    getNowDateFilter(){
      let dateFilter = new Date();
      return `${dateFilter.getFullYear()}-${dateFilter.getMonth()+1}-${dateFilter.getDate()}`;
    },
    getTreeMonthOldFilter(){
      
      let dateNow = new Date();
      dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
      let milissegundos_por_dia = 1000 * 60 * 60 * 24;
      let date = new Date(dateNow.getTime() - 91 * milissegundos_por_dia);
      return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
    },
    downloadOrders(){
      this.disabled = true;
      let results = this.submitFilter();
      
      results.then((response) => {

        let headerArray = [[
          this.$i18n.t('billingNumber'),
          this.$i18n.t('order'),
          this.$i18n.t('purchaseOrder'),
          this.$i18n.t('billingDate'),
          this.$i18n.t('vencimientoDate'),
          this.$i18n.t('status'),
          this.$i18n.t('totalValue'),
        ]];
        
        response.data.lista.map(function(data){
          headerArray.push([
            data.INVOICE,
            data.SALES_ORDER,
            data.CUSTOMER_PO,
            formatDateValue(data.DATE_BILLING),
            formatDateValue(data.DUE_DATE),
            data.STATUS_PAYMENT,
            currency(data.PRICE),
          ]);  
        });

        let ws_name = 'Facturas'
        let wb = XLSX.utils.book_new()
        let ws = XLSX.utils.aoa_to_sheet(headerArray)
        XLSX.utils.book_append_sheet(wb, ws, ws_name)

        this.wb = wb

        this.downloadFile()
        this.disabled = false;
      });
    },
    downloadFile(){
      let filename = 'Facturas' + '.xlsx'
      XLSX.writeFile(this.wb, filename)
    },
  }
};
</script>

